import { UAItem } from "@/interfaces/CardItem";

import _ from "lodash";
import { IFiltersUA } from "@/components/DeckBuilder/game/unionArena/filters/getDefaultFilters";
import { getCardNumber } from "@/lib/games/unionArena/getCardDataLocal";
import { DeckCardsMap } from "@/lib/games/onePiece/DeckCommonCardsFilter";

export function filterCards(
  baseSortedCards: UAItem[],
  filters: IFiltersUA,
  defaultFilters: IFiltersUA,
  deckCardsMap: DeckCardsMap,
): UAItem[] {
  let filteredCards: UAItem[] = [];

  if (_.isEqual(filters, defaultFilters)) {
    return baseSortedCards;
  }

  for (const card of baseSortedCards) {
    let shouldAdd = true;

    if (filters.archetype && filters.archetype !== "") {
      const cards = deckCardsMap[filters.archetype].cards;
      if (!cards.includes(getCardNumber(card.id))) {
        shouldAdd = false;
      }
    }

    // Name filter
    if (filters.search !== "") {
      if (shouldAdd) {
        if (filters.searchSelect.has("name")) {
          // search only in name. Need to improve this further like magic's system
          shouldAdd = card.name
            .toLowerCase()
            .includes(filters.search.toLowerCase());
        } else if (filters.searchSelect.has("effect")) {
          shouldAdd = card.effect
            .toLowerCase()
            .includes(filters.search.toLowerCase());
        } else if (filters.searchSelect.has("trigger")) {
          shouldAdd = false;
          if (card.trigger) {
            shouldAdd =
              shouldAdd ||
              card
                .trigger!.toLowerCase()
                .includes(filters.search.toLowerCase());
          }
        } else if (filters.searchSelect.has("affinity")) {
          shouldAdd =
            shouldAdd &&
            card.affinity.toLowerCase().includes(filters.search.toLowerCase());
        } else {
          // check everything
          shouldAdd =
            card.name.toLowerCase().includes(filters.search.toLowerCase()) ||
            card.effect.toLowerCase().includes(filters.search.toLowerCase()) ||
            card.card_type
              .toLowerCase()
              .includes(filters.search.toLowerCase()) ||
            card.id.toLowerCase().includes(filters.search.toLowerCase());
          if (card.trigger) {
            shouldAdd =
              shouldAdd ||
              card
                .trigger!.toLowerCase()
                .includes(filters.search.toLowerCase());
          }
        }
      }
    }

    // Color filter
    if (filters.color.size !== 0) {
      const colorsToSearch = Array.from(filters.color);
      const curColors = card.color
        .split("/")
        .map((element: string) => element.toLowerCase());
      shouldAdd =
        shouldAdd &&
        curColors.some((color: string) => colorsToSearch.includes(color));
    }

    // Cost filter
    if (filters.cost.size !== 0) {
      const curCost = String(card.energy_cost);
      shouldAdd = shouldAdd && filters.cost.has(curCost);
    }

    // AP Cost filter
    if (filters.apCost.size !== 0) {
      const curAPCost = String(card.ap_cost);
      shouldAdd = shouldAdd && filters.apCost.has(curAPCost);
    }

    // Power filter
    if (filters.battlePower.size !== 0) {
      let curPower = String(card.battle_power);
      if (curPower === "-") {
        curPower = "0";
      }
      shouldAdd = shouldAdd && filters.battlePower.has(curPower);
    }

    // Card type filter
    if (filters.cardType.size !== 0) {
      if (filters.cardType.has("Site")) {
        shouldAdd =
          shouldAdd &&
          (card.card_type === "Site" || card.card_type === "Field");
      } else {
        shouldAdd = shouldAdd && filters.cardType.has(card.card_type);
      }
    }

    // Attribute filter
    // if (filters.attribute.size !== 0) {
    //   let curAttribute = String(card.card_set);
    //   if (curAttribute.includes("/")) {
    //     curAttribute = curAttribute.replace("/", "_");
    //   }
    //   shouldAdd =
    //     shouldAdd && filters.attribute.has(curAttribute.toLowerCase());
    // }

    // Set filter
    if (
      filters.set !== "" &&
      filters.set !== undefined &&
      filters.set !== null
    ) {
      shouldAdd = shouldAdd && card.id.includes(filters.set);
    }

    // Lang filter
    if (filters.lang.size !== 0) {
      const vals: string[] = Array.from(filters.lang) as string[];
      if (vals.length === 1) {
        shouldAdd = shouldAdd && card.src === vals[0];
      }
    }

    if (shouldAdd) {
      filteredCards.push(card as UAItem);
    }
  }

  return filteredCards;
}
